import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import axios from 'axios'


const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 10px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;

  h2 {
    color: #575757;
  }

`;


const Table = styled.table`
  width: 98%;
  min-width: 800px;
  background-color: #fff;
  padding: 10px 10px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    display: block;
  }
`;



const Thead = styled.thead`
  @media (max-width: 768px) {
    display: none;
  }
`;

const Tbody = styled.tbody`
  padding-bottom: 25px; 

  @media (max-width: 768px) {
    display: block; /* Torna cada linha um card */
  }
`;

const Tr = styled.tr`
  text-align: center;
  gap: 5px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: none; /* Oculta cabeçalhos no layout de cards */
  }
`;

const Td = styled.td`
  
  font-size: 14px;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align:start;
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;


const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0px;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Grid = ({ onEdit, usuarios }) => {




  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(usuarios);
  const [isLoading, setIsLoading] = useState(true);

  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = usuarios.filter((user) => {
        const cracha = (user.COD_FUNCIONARIO || '').toString().toLowerCase();
        const login = (user.LOGON || '').toLowerCase();
        const nome = (user.NOME || '').toLowerCase();


        return (
          cracha.includes(term.toLowerCase()) ||
          login.includes(term.toLowerCase()) ||
          nome.includes(term.toLowerCase())

        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, usuarios]);


  //---------------------------------------FUNÇÂO DE ORDENAÇÂO---------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);


  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };


  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };


  //--------------------------------------------------------------------------------------------------------------//

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };


  //------------------------------------------------------------------------------------------//

  return (



    <Container>
      <h2>Usuários que acessam <strong>{onEdit.DESC_MODULO} - {onEdit.DESC_PAGINA}</strong>:</h2>
      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar... Ex: login, nome ou crachá"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div>


      </Td3>
      <Table >
        <Thead hideOnMobile>

          <Tr>
            <Th onClick={() => onColumnClick("COD_FUNCIONARIO")} className={getSortClass("COD_FUNCIONARIO")}>
              Crachá: {getSortIcon("COD_FUNCIONARIO")}
            </Th>
            <Th onClick={() => onColumnClick("LOGON")} className={getSortClass("LOGON")}>
              Login: {getSortIcon("LOGON")}
            </Th>

            <Th onClick={() => onColumnClick("NOME")} className={getSortClass("NOME")}>
              Descrição: {getSortIcon("NOME")}
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item, i) => (
            <Tr key={i}>
              <Td width="auto" data-label="Crachá:">{item.COD_FUNCIONARIO}</Td>
              <Td width="auto" data-label="Login:">{item.LOGON}</Td>
              <Td width="auto" data-label="Nome:">{item.NOME}</Td>

            </Tr>
          ))}
        </Tbody>

      </Table>

    </Container>
  );
};


export default Grid;
